// extracted by mini-css-extract-plugin
export default {"cards":"styles_cards__S7DjA","card":"styles_card__Xppae"};